module.exports = __webpack_public_path__ + "static/media/machine-bt.0f3d600a.ttf";